export const pt = {
  'classification failed': 'A classificação falhou',
  'lung parenchyma attenuation classification fail':
    'Falha na classificação de atenuação do parênquima pulmonar',
  'lung parenchyma segmentation fail':
    'Falha na segmentação do parênquima pulmonar',
  'segmentation failed': 'A segmentação falhou',
  // rad: 'Radiografia',
  // tom: 'Tomografia sem contraste',
  // tomc: 'Tomografia com contraste',
  attention: 'Atenção',
  actions: 'Ações',
  abdomen: 'Abdômen',
  Abnormal: 'Anormal',
  add: 'Adicionar',
  addANewAdministrator: 'Adicionar um novo responsável',
  addAnImageFile: 'Adicione um arquivo de imagem',
  addExams: 'Exames adicionados', 
  adding: 'Adicionando',
  addLogo: 'Adicionar logo',
  administrator: 'Responsável',
  administratorDetails: 'Dados do responsável',
  administratorAlreadyRegistered: 'O responsável já está cadastrado em outra instituição',
  addNewExam: 'Adicionar novo exame',
  addNewRegister: 'Adicionar novo registro',
  addNewInstitution: 'Adicionar nova instituição',
  addNewUnit: 'Adicionar unidade',
  address: 'Endereço',
  admUser: 'Administrador',
  administratorData: 'Dados do Administrator',
  age: 'Idade',
  agreeWithResultsAi: 'Você concorda com os resultados do HealthSCAN IA?',
  all: 'Todos',
  and: 'e',
  andGetInTouchWithUs: 'e entre em contato conosco',
  angio: 'Angio',
  annotation: 'Módulo de Anotação',
  annotationSentSuccessfully: 'Anotação enviada com sucesso',
  app: 'Aprovado',
  resetFilters: 'Resetar filtros',
  approve: 'Aprovar',
  approveResults: 'Aprovar resultados',
  approveReports: 'Aprovar relatórios',
  approved: 'Aprovado',
  approvedResults: 'Resultados aprovados',
  ar: 'Autorefraction',
  areYouSureDeleteExam: 'Tem certeza que deseja deletar o exame?',
  areYouSureAgreeWithResultsByAi:
    'Tem certeza que concorda com os resultados gerados pela IA do HealthSCAN?',
  asmt: 'Content Assessment Results',
  attachPrintToHelpUnderstandWhatsHappening:
    'Anexe uma ou mais prints para nos ajudar a entender o que está acontecendo',
  attachment: 'Anexo',
  autorefraction: 'Autorrefração',
  au: 'Audio',
  afterConfirmationTheExamDeleted: 'Após confirmação o exame será excluído por completo do exame.',
  back: 'Voltar',
  background: 'Plano de Fundo',

  bdus: 'Bone Densitometry (ultrasound)',
  bi: 'Biomagnetic imaging',
  bmd: 'Bone Densitometry (X-Ray)',
  bmi: 'IMC',
  bodyHeight: 'Altura',
  bodyPart: 'Parte do corpo',
  bodyWeight: 'Peso corporal',
  brain: 'Cérebro',
  cancel: 'Cancelar',
  canOnlyAddOneImage: 'Você só pode inserir uma única imagem',
  changeAdminInstitution: 'Trocar admin de institution',
  changePassword: 'Trocar senha',
  checkYourEmailAndTypeInTheField:
    'Verifique seu e-mail e digite ou cole no campo abaixo',
  city: 'Cidade',
  chest: 'Peito',
  clickHere: 'clique aqui',
  cnpjAlreadyRegistered: 'O CNPJ já está cadastrado em outra instituição',
  comments: 'Comentários',
  complement: 'Complemento',
  confirm: 'Confirmar',
  confirmEmail: 'Você precisa confirmar seu e-mail',
  consolidation: 'Consolidação',
  continue: 'Continuar',
  country: 'País',
  covidModule: 'módulo COVID',
  cpfAlreadyRegistered: 'CPF já cadastrado',
  cpfMustBeValid: 'O CPF deve ser válido',
  cr: 'Radiografia Computadorizada',
  ct: 'Tomografia Computadorizada',
  cnn: 'Acessar Relatório da CNN',
  cyst: 'Cisto',
  dashboard: 'Painel',
  data: 'Dados',
  delete: 'Deletar',
  deleteexam: 'Deletar Exame',
  density: 'densidade',
  densityControl: 'Controle por Densidade',
  description: 'Descrição',
  densitometry: 'Acessar Relatório de Densitometria',
  dg: 'Diaphanography',
  diameter: 'Diâmetro',
  diffuse: 'Difusa',
  donwload: 'Baixar',
  doc: 'Document',
  doctorsName: 'Nome do médico',
  dontWorryYouCanGoTo: 'Não se preocupe, você pode ir para',
  view3dModel: 'Visualizar modelo 3D',
  downloadReport: "Baixar relatório",
  dx: 'Radiografia Digital',
  ecg: 'Electrocardiography',
  edit: 'Editar',
  edition: 'Módulo de Edição',
  editSucess : 'Edição realizada com sucesso 200',
  editUser: 'Editar usuário',
  emailAlreadyRegistered: 'E-mail já cadastrado',
  emailConfirmation: 'Confirmação de e-mail',
  emailConfirmedSuccessfully: 'E-mail confirmado com sucesso',
  emailFieldIsRequired: 'O campo de e-mail é obrigatório',
  emphysema: 'Enfisema',
  enter: 'Entrar',
  enterInstitutionAddress: 'Insira o endereço da instituição',
  enterInstitutionName: 'Insira o nome da instituição',
  enterYourName: 'Insira seu nome',
  enterAMessage: 'Insira uma mensagem',
  eps: 'Cardiac Electrophysiology',
  err: 'Não processado',
  inc: 'Inconclusivo',
  errorApprovingReport: 'Erro ao aprovar o relatório',
  errorConfirmingEmail: 'Erro ao confirma o e-mail. Por favor, tente novamente',
  errorDisapprovingReport: 'Erro ao reprovar relatório',
  errorRegisteringInstitution: 'Erro ao registrar instituição. Por favor, tente novamente.',
  errorRegisteringExam: 'Erro ao cadastrar exame. Por favor, tente novamente.',
  errorRequestingExamUpdate: 'Erro ao solicitar atualização do exame. Por favor, tente novamente.',
  errorSubmittingYourReview: 'Erro ao enviar sua revisão',
  errorTryingToLoadInitialDataTryingLoadAgain:
    'Error trying to load initial data. Trying to load again',
  errorReadingDicomData: 'Erro ao extrair dados de arquivos DICOM.',
  errorUploadingDicomFile: 'Erro ao fazer o upload do arquivo DICOM',
  errorWhenSendingTheAnnotation:
    'Erro ao enviar a anotação. Por favor, tente novamente.',
  errorWhenSendingTheSegmentation:
    'Erro ao enviar a segmentação. Por favor, tente novamente.',
  es: 'Endoscopy',
  examDate: 'Data do Exame',
  examRegistration: 'Data do Cadastro',
  examDescription: 'Descrição do exame',
  examImagesNotAvailableYet: 'Imagens do exame ainda não disponíveis',
  examPanel: 'Painel de exames',
  examType: 'Tipo de exame',
  exameType: 'Tipo de Exame',
  exampleEmail : 'exemplo@email.com',
  exam: 'exame',
  exams: 'exames',
  examsPanel: 'painel de exames',
  examsPerMonth: 'exames por mês',
  examsThisMonth: 'Exames este mês',
  examUpdateRequestedSuccessfully: 'Solicitação de atualização do exame realizada com sucesso, por favor aguarde alguns minutos.',
  exitWithoutSaving: 'Tem certeza que deseja sair desta página? Os exames não cadastrados serão perdidos.',
  extractingDataFromDicomFiles: 'Extraindo os dados dos arquivos DICOM',
  extractingImagesFromDicomFiles: 'Extraindo as imagens dos arquivos DICOM',
  f: 'Feminino',
  fid: 'Fiducials',
  filterByExamType: 'Filtrar por tipo de exame',
  filterExamByStatus: 'Filtrar exames por status',
  filterExamsByDoctor: 'Filtrar exames por médico',
  filterExamsByPatient: 'Filtrar exames por paciente',
  forgotMyPassword: 'Esqueci minha senha',
  frequency: 'frequência',
  from1To4ImageFiles: 'de 1 a 4 arquivos de imagem',
  generalSuport: 'Suporte geral',
  gm: 'General Microscopy',
  goToExamsPanel: 'Ir para Painel de Exames',
  hc: 'Hard Copy',
  hd: 'Hemodynamic Waveform',
  headquarters: 'Matriz',

  healthscanPlan: 'Plano HealthSCAN',
  help: 'ajuda',
  helpPage: 'página de ajuda',
  high: 'alto',
  highAttenuation: 'Alta atenuação',
  highFemale: 'alta',
  howCanWeHelpYou: 'Como podemos te ajudar?',
  inc: 'Inconclusivo',
  iIsYourFirstAccess: 'Caso seja seu primeiro acesso',
  ifYouNeedSupportGoToThe: 'Se você precisar de suporte, vá para a',
  ifYouWantChangeItPleaseGetTouchWithUs:
    'Se você quiser alterá-lo, por favor, entre em contato conosco',
  ifYouWantReplaceMainAccountAdminContactUs:
    'Se você deseja substituir o administrador da conta principal, entre em contato conosco',
  image: 'imagem',
  imageNotAvailable: 'Imagem não disponível',
  images: 'imagens',
  insertMatriculation: 'Inserir matricula',
  inscription: 'Inscrição(CRM/ Matrícula/ Prontuário)',
  information: 'Informação',
  informations: 'Informações',
  insertRegistry: 'Insira a matrícula',
  institution: 'instituição',
  Institution: 'Instituição',
  institutions: 'instituições',
  institutionDetails: 'Dados da instituição',
  institutionRegistration: 'Registro de Instituição',
  institutionsTitle: 'Instituições',
  institutionSuccess: 'Instituição adicionada com sucesso',
  invalidEmail: 'E-mail inválido',
  invalidEmailOrPassword: 'E-mail ou senha inválidos',
  invalidField: 'Campo inválido',
  invalidFieldMaximum250Characters: 'Campo inválido. Máximo de 250 caracteres',
  invalidFieldMaximum50Characters: 'Campo inválido. Máximo de 50 caracteres',
  invalidFieldMustHave11Numbers: 'Campo inválido. Deve ter 11 números',
  invalidFieldMustHave14Numbers: 'Campo inválido. Deve ter 14 números',
  invalidFieldMustHave8Numbers: 'Campo inválido. Deve ter 8 números',
  invalidNumber: 'Número inválido',
  invalidValue: 'Valor inválido',
  invertContrast: 'Inverter cor',
  io: 'Intra-Oral Radiography',
  iol: 'Intraocular Lens Data',
  inserRegistration: "Insira a matrícula",
  itsNotPossibleSendMoreThan4ImagesByEmail:
    'Não é possível enviar mais de 4 imagens por e-mail',
  ivoct: 'Intravascular Optical Coherence Tomography',
  ivus: 'Intravascular Ultrasound',
  ker: 'Keratometry',
  ko: 'Key Object Selection',
  len: 'Lensometry',
  loadingInstitutionList: 'Carregando lista de instituições...',
  loadingInstitutionSummary: 'Carregando informações da matriz...',
  loading3DModel: 'Carregando modelo 3D...',
  loadingExamImages: 'Carregando imagens do exame...',
  loadingPDF: 'Carregando PDF...',
  loadingExamInfo: 'Carregando informações sobre o exame...',
  loadingExamSummaryAndFilters: 'Carregando resumo de exames e filtros...',
  loadingRegisteredDoctors: 'Carregando os médicos cadastrados',
  loadingRegisteredInstitutions: 'Carregando instituições cadastradas',
  logoImage: 'Imagem do Logo',
  low: 'baixo',
  lung: 'Pulmão',
  lowAttenuation: 'Baixa atenuação',
  lowFemale: 'baixa',
  limits: 'Limites',
  ls: 'Laser surface scan',
  m: 'Masculino',
  makeYourLogin: 'Faça o seu Login',
  matriculation: 'Matrícula',
  medicalAssistant: 'Assistente Médico',
  medicalRecord: 'Registro Médico',
  message: 'Mensagem',
  matriculation: 'Matrícula',
  mg: 'Mammography',
  mild: 'Suave',
  modality: 'Modalidade',
  model3dNotAvailableYet: 'Modelo 3D não disponível ainda',
  moderate: 'Moderada',
  mr: 'Magnetic Resonance',
  mustSelectAdministrator: 'É necessário selecionar ou adicionar um responsável',
  myprofile: 'Meu perfil',
  name: 'Nome',
  nameTooLong: 'Nome grande demais',
  nameRepportExamToSaveAs: 'Nome de relatório de exame para salvar como',
  new: 'Novo',
  newAdministratorError: 'Erro ao adicionar um novo responsável',
  newAdministratorSuccess: 'Responsável adicionado com sucesso',
  newer: 'Data de exame mais recente',
  next: 'Próximo',
  niftiError: 'A ferramenta não está disponível para este exame pois não foi possível converter a série em volume NIfTI',
  nm: 'Nuclear Medicine',
  normal: 'Normal',
  Normal: 'Normal',
  notifications: 'Notificações',
  notificationViewed: 'ABERTA',
  notificationNotViewed: 'ABRA',
  noResults: 'Sem resultados',
  noActiveUser : 'Parece que não conseguimos encontrar nenhum usuário ativo.',
  noChanges: 'Sem alteração',
  noResultsDescription: 'Parece que não conseguimos encontrar nenhum resultado a partir de sua busca.',
  noUpdatesAvailable: 'Nenhuma atualização disponível no momento.',
  normalAttenuation: 'Atenuação normal',
  number: 'Número',
  numberOfExams: 'Número de Exames',
  o: 'Outro',
  outros: 'Outros',
  oam: 'Ophthalmic Axial Measurements',
  oct: 'Optical Coherence Tomography (non-Ophthalmic)',
  older: 'Data de exame mais antiga',
  op: 'Ophthalmic Photography',
  opacity: 'Opacidade',
  operatorImage: 'Imagem do Operador',
  opm: 'Ophthalmic Mapping',
  opt: 'Ophthalmic Tomography',
  pro: 'Processando',
  opv: 'Ophthalmic Visual Field',
  overwriteExistingAnnotations: 'Sobrescrever',
  sort: 'Ordenar',
  oss: 'Optical Surface Scan',
  ot: 'Other',
  our: 'nosso',
  ourOfficeHoursAre:
    'Nosso horário de atendimento é de segunda a sexta-feira, das 9h às 17h (leste), e tentamos responder às solicitações de suporte dentro de 1 dia útil',
  ohifError: 'Não foi possível exibir o visualizador pois o exame pode ter sido excluído ou está indisponível no servidor de imagem.',
  observation: 'Observação',
  pageNotFound: 'Página não encontrada',
  panelControl: 'Painel de controle',
  pathology: 'Patologia',
  patient: 'Paciente',
  patientInformation: 'Informação do paciente',
  patientName: 'Nome do paciente',
  patientsName: 'Nome do paciente',
  patientId: 'ID Paciente',
  patient_name_asc: 'Nome do paciente (A-Z)',
  patient_name_desc: 'Nome do paciente (Z-A)',
  performance: 'Desempenho',
  plan: 'Plan',
  pleaseFillOutThisFormToGetInTouch:
    'Por favor, preencha o formulário para entrar em contato',
  postalCode: 'Código postal',
  pr: 'Presentation State',
  previous: 'Anterior',
  privacyPolicy1: 'POLÍTICA DE PRIVACIDADE\n\n\
                  Olá! Assim como você, nós nos preocupamos com a privacidade! Afinal, privacidade é um direito previsto na ',
  brazilianConstitution: 'Constituição Brasileira',
  privacyPolicy2: '  .\
                  Assim, a empresa Meditec - Medical Digital Imaging Technologies Ltda. respeita a sua privacidade em relação a \
                  qualquer informação sua que possamos coletar.\n\n\
                  É importante lembrar que o nosso site pode conter links para sites externos que não são operados \
                  por nós. Esteja ciente de que não temos controle sobre o conteúdo e práticas desses sites e não \
                  podemos aceitar responsabilidade por suas respectivas políticas de privacidade.\n\n\
                  1. Quais tipos de dados que coletamos?\n\n\
                  Nós recebemos, coletamos e arquivamos as informações que você adiciona em nosso site ou nos fornece \
                  de qualquer outra forma. Além disso, nós coletamos o endereço IP utilizado para conectar o seu computador \
                  à Internet; informações do computador e internet. Nós poderemos utilizar ferramentas para medir e coletar \
                  informações de navegação, incluindo o tempo de resposta das páginas, tempo total da visita em determinadas páginas, \
                  informações de interação com página e os métodos utilizados para deixar a página.\n\n\
                  Nós também coletamos informações de identificação pessoal (incluindo nome, e-mail, meios de comunicação).\n\n\
                  2. Como coletamos esses dados pessoais?\n\n\
                  Quando você realiza cadastro em nosso site, como parte do procedimento, nós coletamos as informações pessoais fornecidas \
                  como: o seu nome, telefone e endereço de e-mail. As suas informações pessoais serão utilizadas para as ações específicas \
                  citadas abaixo apenas.\n\n\
                  3. Porque coletamos esses dados pessoais?\n\n\
                  Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe prestar um serviço, com o seu conhecimento \
                  e consentimento. Em resumo, coletamos esses dados para: prestar serviços advocatícios (incluindo consultorias avulsas) e \
                  elaborar contratos e peças jurídicas; prestar aos nossos clientes assistência e suporte jurídico contínuos; poder entrar em \
                  contato com nossos Visitantes e Usuários com avisos gerais ou personalizados relacionados ao serviço prestado; criar dados estatísticos \
                  agregados e outras informações não pessoais agregadas e/ou inferidas, que podem ser usadas por nós ou por nossos parceiros comerciais \
                  para prestar e melhorar nossos respectivos serviços; cumprir quaisquer leis e regulamentos aplicáveis.\n\n\
                  4. Onde armazenamos, compartilhamos ou utilizamos os dados?\n\n\
                  As informações coletadas são utilizadas e armazenadas em nuvem pelo período de dois anos e somente são compartilhadas com pessoas \
                  jurídicas terceirizadas ou médicos parceiros. Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, \
                  exceto quando exigido por lei.\n\n\
                  5. Como nos comunicamos com nossos clientes e visitantes do nosso site?\n\n\
                  Nós poderemos entrar em contato com você para notificá-lo ou esclarecer alguma informação relacionada ao serviço prestado por nós; \
                  para ajudá-lo a resolver alguma questão relacionada ao serviço prestado; para notificá-lo sobre faturas, inclusive por meio de empresa \
                  terceirizada; para pesquisas ou questionários; para novidades sobre nossa atuação ou para qualquer outro motivo que seja necessário \
                  revisar o nosso contrato, de acordo com as leis locais. Para isso, poderemos entrar em contato via e-mail, telefone, mensagens de texto \
                  e/ou correio.\n\n\
                  POLÍTICA DE COOKIES\n\n\
                  1. O que são cookies?\n\n\
                  Como é prática comum em quase todos os sites profissionais, este site usa cookies, que são pequenos arquivos baixados no seu computador, \
                  para melhorar sua experiência. Esta página descreve quais informações eles coletam, como as usamos e por que às vezes precisamos armazenar \
                  esses cookies. Também compartilharemos como você pode impedir que esses cookies sejam armazenados, no entanto, isso pode fazer o downgrade \
                  ou \'quebrar\' certos elementos da funcionalidade do site.\n\n\
                  2. Como usamos os cookies?\n\n\
                  Utilizamos cookies por vários motivos, detalhados abaixo. Infelizmente, na maioria dos casos, não existem opções padrão do setor para \
                  desativar os cookies sem desativar completamente a funcionalidade e os recursos que eles adicionam a este site. É recomendável que você \
                  deixe todos os cookies se não tiver certeza se precisa ou não deles, caso sejam usados ​​para fornecer um serviço que você usa.\n\n\
                  3. Desativar cookies\n\n\
                  Você pode impedir a configuração de cookies ajustando as configurações do seu navegador (consulte a Ajuda do navegador para saber como \
                  fazer isso). Esteja ciente de que a desativação de cookies afetará a funcionalidade deste e de muitos outros sites que você visita. \
                  A desativação de cookies geralmente resultará na desativação de determinadas funcionalidades e recursos deste site. Portanto, é recomendável \
                  que você não desative os cookies.\n\
                  Os links a seguir explicam como acessar as configurações de cookies em vários navegadores:\n\n\
                  ',
  firefoxCookieConfig: 'Configurações de Cookies no Firefox',
  explorerCookieConfig: 'Configurações de Cookies no Internet Explorer',
  exportData: 'Exportar dados',
  chromeCookieConfig: 'Configurações de Cookies no Google Chrome',
  safariOSXCookieConfig: 'Configurações de Cookies no Safari (OS X)',
  safariOSCookieConfig: 'Configurações de Cookies no Safari (iOS)',
  androidCookieConfig: 'Configurações de Cookies no Android',
  privacyPolicy3: '\nPara não ser rastreado pelo Google Analytics em todos os sites, ',
  privacyPolicy4: '\n\nATUALIZAÇÕES DA POLÍTICA DE PRIVACIDADE\n\n\
                  Nós temos o direito de modificar essa política de privacidade a qualquer momento, portanto consulte regularmente. As alterações serão \
                  imediatamente colocadas em práticas após a alteração em nosso site. Caso realizarmos mudanças referentes aos materiais dessa política, \
                  você será notificado para que esteja ciente das informações que coletamos e como as utilizamos.\n\n\
                  MAIS INFORMAÇÕES\n\n\
                  Caso você não queira mais que seja possível para nós coletar as suas informações pessoais, por favor entre em contato através do email: \
                  contato@petrec.com.br .\n\n\
                  Se você tiver quaisquer dúvidas sobre esta Política de Privacidade, ou queira acessar, corrigir ou deletar qualquer informação que tenhamos \
                  coletado sobre você, fique à vontade para contatar-nos pelo e-mail contato@petrec.com.br .',
  privacyPolicyTitle: 'Política de Privacidade',
  privacyPolicyDescription: 'Esta Política de Privacidade destina-se a ajudar você a entender quais informações coletamos, porque as coletamos e como \
                              você pode atualizar, gerenciar, exportar e excluir essas informações.',
  processing: 'Processando',
  pt: 'Positron emission tomography (PET)',
  pdfError: 'Não foi possível exibir o arquivo PDF pois o exame pode ter sido excluído ou o arquivo está indisponível no servidor.',
  pulmonaryInvolvementExtent: 'Extensão do Envolvimento Pulmonar',
  pulmonaryInvolvementSeverity: 'Gravidade do Envolvimento Pulmonar',
  px: 'Panoramic X-Ray',
  quantitiveAnalysis: 'Análise Quantitativa',
  radiographies: 'Radiografias',
  readingDicomData: 'Extraindo dados dos arquivos DICOM',
  reg: 'Registration',
  register: 'Cadastrar',
  registerAdministrator: 'Registrar Responsável',
  registered: 'registrados',
  registeringExam: 'Cadastrando exame',
  registrations: 'Registros',
  registrationDate: 'Data do registro',
  registerSomeObservation: 'Registre alguma observação sobre o exame (opcional)',
  registration_newer: 'Data de cadastro mais recente no HealthScan',
  registration_older: 'Data de cadastro mais antiga no HealthScan',
  registry: 'Número de acesso',
  report: 'Relatório',
  reportNotApprovedBecauseItHasFeedback:
    'Relatório não aprovado porque já possui feedback',
  reportSuccessfullyApproved: 'Relatório aprovado com sussesso',
  reportSuccessfullyDisapproved: 'Relatório desaprovado com sussesso',
  reports: 'Relatórios',
  requestReview: 'Solicitar revisão',
  evaluation: 'avaliação',
  evaluations: 'Avaliações',
  noEvaluations: 'Nenhuma avaliação encontrada para este relatório.',
  justifications: 'Justificativas',
  anonymous: 'Anônimo',
  save: 'Salvar',
  saving: 'Salvando...',
  errorUpdatingFeedback: 'Erro ao atualizar avaliação.',
  errorDeletingFeedback: 'Erro ao excluir avaliação.',
  confirmDeleteFeedback: 'Tem certeza que deseja excluir esta avaliação?',
  requiredField: 'Campo obrigatório',
  changeReview: 'Alterar revisão',
  resp: 'Respiratory Waveform',
  responsible: 'Responsável',
  result: 'Resultado',
  rev: 'Revisado',
  rf: 'Radio Fluoroscopy',
  rg: 'Radiographic imaging (conventional film/screen)',
  rtdose: 'Radiotherapy Dose',
  rtimage: 'Radiotherapy Image',
  rtplan: 'Radiotherapy Plan',
  rtrecord: 'RT Treatment Record',
  rtstruct: 'Radiotherapy Structure Set',
  rwv: 'Real World Value Map',
  saveYourAnnotationAs: 'Salve sua anotação como',
  saveYourSegmentationAs: 'Salve sua segmentação como',
  scanQrCode: 'Ler QR code',
  searchExamByMedicalRecordPacient:
    'Buscar exames por registro médico, nome do paciente…',
  searchInstitutions: "Pesquisar instituições",
  searchUser: "Pesquisar usuários",
  searchClass: "Pesquisar uma classe",
  seeLess: 'Ver menos',
  seeMore: 'Ver mais',
  seeResults: 'Ver resultados',
  seg: 'Segmentation',
  segmentationSentSuccessfully: 'Segmentação enviada com sucesso',
  selectATopic: 'Selecione um tópico',
  selectAClass: 'Selecione uma classe',
  selectAnOption: 'Selecione uma opção',
  selectImagesToRegisterExams: 'Selecione imagens para registrar exames',
  selectInstitution: 'Selecione a instituição',
  selectInstitutionToRegisterExams:
    'Selecione a instituição para registrar exames',
  selectOneOrMoreOptionsToGetBetterResults:
    'Selecione uma ou mais opções que exigem mais atenção para obter melhores resultados:',
  selectHeadquarters: 'Selecione uma matriz',
  selectAdministrator: 'Selecione um responsável',
  selectUserType :'Selecione um tipo de usuário',
  sendFeedback: 'Enviar feedback',
  seriesWithoutDescription: 'Série sem descrição',
  serieDescription: 'Descrição da Série *',
  serieDescriptionWithoutAsterisk: 'Descrição da Série',
  series_uid: 'UID da Série',
  severe: 'Severa',
  sex: 'Sexo',
  sm: 'Slide Microscopy',
  smr: 'Stereometric Relationship',
  sr: 'SR Document',
  srf: 'Subjective Refraction',
  stain: 'Automated Slide Stainer',
  status: 'Situação',
  submit: 'Enviar',
  telephone: 'Telefone',
  tellMoreAboutDisagreeInResults:
    'Conte-nos mais sobre o que você discorda nos resultados',
  termsOfService: 'TERMOS E CONDIÇÕES GERAIS DE USO DO HEALTHSCAN\n\
                  ----\n\
                  VISÃO GERAL\n\n\
                  Os serviços do Healthscan são fornecidos pela pessoa jurídica com a seguinte Razão Social/nome:Meditec \
                  - Medical Digital Imaging Technologies Ltda., com nome fantasia MEDITEC, inscrito no CNPJ sob o n\º 45.144.055/0001-03, \
                  titular da propriedade intelectual sobre software, website, aplicativos, conteúdos e demais ativos relacionados à \
                  plataforma Healthscan.\n\n\
                  SEÇÃO 1 - DO OBJETO\n\n\
                  A plataforma visa licenciar o uso de seu software, website, aplicativos e demais ativos de propriedade intelectual, \
                  fornecendo ferramentas para auxiliar e dinamizar o dia a dia dos seus usuários. A plataforma caracteriza-se pela prestação \
                  do seguinte serviço: software de análise de imagens de exames para facilitar o diagnóstico.\n\n\
                  SEÇÃO 2 - DA ACEITAÇÃO\n\n\
                  O presente Termo estabelece obrigações contratadas de livre e espontânea vontade, por tempo indeterminado, entre a plataforma \
                  e as pessoas físicas ou jurídicas, usuárias do software. Ao utilizar a plataforma o usuário aceita integralmente as presentes \
                  normas e compromete-se a observá-las, sob o risco de aplicação das penalidade cabíveis. A aceitação do presente instrumento é \
                  imprescindível para o acesso e para a utilização de quaisquer serviços fornecidos pela empresa. Caso não concorde com as \
                  disposições deste instrumento, o usuário não deve utilizá-los.\n\n\
                  SEÇÃO 3 - DO ACESSO AOS USUÁRIOS\n\n\
                  Serão utilizadas todas as soluções técnicas à disposição do responsável pela plataforma para permitir o acesso ao serviço \
                  24 (vinte e quatro) horas por dia, 7 (sete) dias por semana. No entanto, a navegação na plataforma ou em alguma de suas páginas \
                  poderá ser interrompida, limitada ou suspensa para atualizações, modificações ou qualquer ação necessária ao seu bom funcionamento.\n\n\
                  (Se há necessidade de cadastro para uso da plataforma)\n\n\
                  SEÇÃO 4 - DO CADASTRO\n\n\
                  O acesso às funcionalidades da plataforma exigirá a realização de um cadastro prévio e, a depender dos serviços ou produtos escolhidos, \
                  o pagamento de determinado valor.\n\n\
                  Ao se cadastrar o usuário deverá informar dados completos, recentes e válidos, sendo de sua exclusiva responsabilidade manter referidos \
                  dados atualizados, bem como o usuário se compromete com a veracidade dos dados fornecidos.\n\n\
                  O usuário se compromete a não informar seus dados cadastrais e/ou de acesso à plataforma a terceiros, responsabilizando-se integralmente \
                  pelo uso que deles seja feito.\n\n\
                  Menores de 18 anos e aqueles que não possuírem plena capacidade civil deverão obter previamente o consentimento expresso de seus responsáveis \
                  legais para utilização da plataforma e dos serviços ou produtos, sendo de responsabilidade exclusiva dos mesmos o eventual acesso por menores \
                  de idade e por aqueles que não possuem plena capacidade civil sem a prévia autorização.\n\n\
                  Mediante a realização do cadastro o usuário declara e garante expressamente ser plenamente capaz, podendo exercer e usufruir livremente dos serviços e produtos.\n\n\
                  O usuário deverá fornecer um endereço de e-mail válido, através do qual o site realizará todas comunicações necessárias.\n\n\
                  Após a confirmação do cadastro, o usuário possuirá um login e uma senha pessoal, a qual assegura ao usuário o acesso individual à mesma. Desta forma, \
                  compete ao usuário exclusivamente a manutenção de referida senha de maneira confidencial e segura, evitando o acesso indevido às informações pessoais.\n\n\
                  Toda e qualquer atividade realizada com o uso da senha será de responsabilidade do usuário, que deverá informar prontamente a plataforma em \
                  caso de uso indevido da respectiva senha.\n\n\
                  Não será permitido ceder, vender, alugar ou transferir, de qualquer forma, a conta, que é pessoal e intransferível.\n\n\
                  Caberá ao usuário assegurar que o seu equipamento seja compatível com as características técnicas que viabilize a utilização \
                  da plataforma e dos serviços ou produtos.\n\n\
                  O usuário poderá, a qualquer tempo, requerer o cancelamento de seu cadastro junto ao software. O seu descadastramento será realizado o mais \
                  rapidamente possível, desde que não sejam verificados débitos em aberto.\n\n\
                  O usuário, ao aceitar os Termos e Política de Privacidade, autoriza expressamente a plataforma a coletar, usar, armazenar, tratar, ceder ou \
                  utilizar as informações derivadas do uso dos serviços, do site e quaisquer plataformas, incluindo todas as informações preenchidas pelo \
                  usuário no momento em que realizar ou atualizar seu cadastro, além de outras expressamente descritas na Política de Privacidade que deverá \
                  ser autorizada pelo usuário.\n\n\
                  SEÇÃO 5 - DOS SERVIÇOS\n\n\
                  A plataforma poderá disponibilizar para o usuário um conjunto específico de funcionalidades e ferramentas para otimizar o uso dos serviços. \
                  Na plataforma os serviços oferecidos estão descritos e apresentados com o maior grau de exatidão, contendo informações sobre suas \
                  características, qualidades, quantidades, composição, preço, garantia, prazos de validade e origem, entre outros dados, bem como sobre os \
                  riscos que apresentam à saúde e segurança do usuário. Antes de finalizar a compra sobre determinado serviço, o usuário deverá se informar \
                  sobre as suas especificações e sobre a sua destinação. A entrega de serviços na plataforma será informada no momento da finalização da compra.\n\n\
                  SEÇÃO 6 - DOS PREÇOS\n\n\
                  A plataforma se reserva no direito de reajustar unilateralmente, a qualquer tempo, os valores dos serviços ou produtos sem consulta ou anuência \
                  prévia do usuário. Os valores aplicadas são aqueles que estão em vigor no momento do pedido. Os preços são indicados em reais, as quais são \
                  especificadas à parte e são informadas ao usuário antes da finalização do pedido. Na contratação de determinado serviço ou produto, a plataforma \
                  poderá solicitar as informações financeiras do usuário, como CPF, endereço de cobrança e dados de cartões. Ao inserir referidos dados o usuário \
                  concorda que sejam cobrados, de acordo com a forma de pagamento que venha a ser escolhida, os preços então vigentes e informados quando da \
                  contratação. Referidos dados financeiros poderão ser armazenadas para facilitar acessos e contratações futuras. A contratação dos serviços será \
                  renovada automaticamente pela plataforma, independentemente de comunicação ao usuário, mediante cobrança periódica da mesma forma de pagamento \
                  indicada pelo usuário quando da contratação do serviço.\n\n\
                  SEÇÃO 7 - DO CANCELAMENTO\n\n\
                  O usuário poderá cancelar a contratação dos serviços de acordo com os termos que forem definidos no momento de sua contratação. Ainda, o \
                  usuário também poderá cancelar os serviços em até 7 (sete) dias após a contratação, mediante contato com a Meditec, de acordo com o Código de \
                  Defesa do Consumidor (Lei n\º. 8.078/90). O serviço poderá ser cancelado por:\n\n\
                  a) parte do usuário: nessas condições os serviços somente cessarão quando concluído o ciclo vigente ao tempo do cancelamento;\n\
                  b) violação dos Termos de Uso: os serviços serão cessados imediatamente.\n\n\
                  (Se há cláusula de troca e devolução)\n\n\
                  SEÇÃO 8 - DO SUPORTE\n\n\
                  Em caso de qualquer dúvida, sugestão ou problema com a utilização da plataforma, o usuário poderá entrar em contato com o suporte, \
                  através do email contato@petrec.com.br . Estes serviços de atendimento ao usuário estarão disponíveis nos seguintes dias e horários: Segunda \
                  à sexta de 09:00 às 18:00.\n\n\
                  SEÇÃO 9 - DAS RESPONSABILIDADES\n\n\
                  É de responsabilidade do usuário:\n\n\
                  a) defeitos ou vícios técnicos originados no próprio sistema do usuário;\n\
                  b) a correta utilização da plataforma, dos serviços oferecidos, prezando pela boa convivência, pelo respeito e cordialidade entre os usuários;\n\
                  c) pelo cumprimento e respeito ao conjunto de regras disposto nesse Termo de Condições Geral de Uso, na respectiva Política de Privacidade e na \
                  legislação nacional e internacional;\n\
                  d) pela proteção aos dados de acesso à sua conta/perfil (login e senha).\n\
                  É de responsabilidade da plataforma Healthscan:\n\n\
                  a) indicar as características do serviço;\n\
                  b) os defeitos e vícios encontrados no serviço oferecido desde que lhe tenha dado causa;\n\
                  c) as informações que foram por ele divulgadas, sendo que os comentários ou informações divulgadas por usuários são de inteira responsabilidade \
                  dos próprios usuários;\n\
                  d) os conteúdos ou atividades ilícitas praticadas através da sua plataforma.\n\n\
                  A plataforma não se responsabiliza por links externos contidos em seu sistema que possam redirecionar o usuário à ambiente externo a sua rede. \
                  Não poderão ser incluídos links externos ou páginas que sirvam para fins comerciais ou publicitários ou quaisquer informações ilícitas, \
                  violentas, polêmicas, pornográficas, xenofóbicas, discriminatórias ou ofensivas.\n\n\
                  SEÇÃO 10 - DOS DIREITOS AUTORAIS\n\n\
                  O presente Termo de Uso concede aos usuários uma licença não exclusiva, não transferível e não sublicenciável, para acessar e fazer uso \
                  da plataforma e dos serviços e produtos por ela disponibilizados.\n\n\
                  A estrutura do site ou aplicativo, as marcas, logotipos, nomes comerciais, layouts, gráficos e design de interface, imagens, ilustrações, \
                  fotografias, apresentações, vídeos, conteúdos escritos e de som e áudio, programas de computador, banco de dados, arquivos de transmissão e \
                  quaisquer outras informações e direitos de propriedade intelectual da razão social Meditec - Medical Digital Imaging Technologies Ltda., \
                  observados os termos da Lei da Propriedade Industrial (Lei n\º 9.279/96), Lei de Direitos Autorais (Lei n\º 9.610/98) e Lei do Software \
                  (Lei n\º 9.609/98), estão devidamente reservados.\n\n\
                  Este Termos de Uso não cede ou transfere ao usuário qualquer direito, de modo que o acesso não gera qualquer direito de propriedade \
                  intelectual ao usuário, exceto pela licença limitada ora concedida.\n\n\
                  O uso da plataforma pelo usuário é pessoal, individual e intransferível, sendo vedado qualquer uso não autorizado, comercial ou \
                  não-comercial. Tais usos consistirão em violação dos direitos de propriedade intelectual da razão social Meditec - Medical Digital Imaging \
                  Technologies Ltda., puníveis nos termos da legislação aplicável.\n\n\
                  SEÇÃO 11 - DAS SANÇÕES\n\n\
                  Sem prejuízo das demais medidas legais cabíveis, a razão social Meditec - Medical Digital Imaging Technologies Ltda. poderá, a qualquer \
                  momento, advertir, suspender ou cancelar a conta do usuário:\n\n\
                  a) que violar qualquer dispositivo do presente Termo;\n\
                  b) que descumprir os seus deveres de usuário;\n\
                  c) que tiver qualquer comportamento fraudulento, doloso ou que ofenda a terceiros.\n\n\
                  SEÇÃO 12 - DA RESCISÃO\n\n\
                  A não observância das obrigações pactuadas neste Termo de Uso ou da legislação aplicável poderá, sem prévio aviso, ensejar a imediata \
                  rescisão unilateral por parte da razão social Meditec - Medical Digital Imaging Technologies Ltda. e o bloqueio de todos os serviços \
                  prestados ao usuário.\n\n\
                  SEÇÃO 13 - DAS ALTERAÇÕES\n\n\
                  Os itens descritos no presente instrumento poderão sofrer alterações, unilateralmente e a qualquer tempo, por parte de Meditec - Medical \
                  Digital Imaging Technologies Ltda., para adequar ou modificar os serviços, bem como para atender novas exigências legais. As alterações \
                  serão veiculadas pelo site healthscan.app e o usuário poderá optar por aceitar o novo conteúdo ou por cancelar o uso dos serviços, caso seja \
                  assinante de algum serviço.\n\n\
                  (Se oferece serviços para assinantes)\n\n\
                  SEÇÃO 14 - DA POLÍTICA DE PRIVACIDADE\n\n\
                  Além do presente Termo, o usuário deverá consentir com as disposições contidas na respectiva Política de Privacidade a ser apresentada a \
                  todos os interessados dentro da interface da plataforma.\n\n\
                  SEÇÃO 15 - DO FORO\n\n\
                  Para a solução de controvérsias decorrentes do presente instrumento será aplicado integralmente o Direito brasileiro.\n\n\
                  Os eventuais litígios deverão ser apresentados no foro da comarca em que se encontra a sede da empresa.\n\n\
                  Perguntas sobre os Termos de serviço devem ser enviadas para nós em contato@petrec.com.br .',
  termsOfServiceTitle: 'Termos e condições de uso',
  termsOfServiceDescription: 'Leia com atenção nossos termos e se necessário faça o download do arquivo em formato PDF.',
  tg: 'Thermography',
  theEmailMustBeValid: 'O e-mail deve ser válido',
  theFieldIsRequired: 'O campo é obrigatório',
  theNameFieldiSRequired: 'O campo de nome é obrigatório',
  theseAreInfoYourHealthscanPlan:
    'Estas são as informações do seu plano HealthSCAN',
  thisFieldIsRequired: 'Este campo é obrigatório',
  thisSoftware: 'Este software está atualmente em fase de testes. Portanto, ainda não disponível para uso comercial.\n\
  Agradecemos sua paciência e colaboração durante esse período.\n\
  Estamos trabalhando para aprimorar a experiência do usuário e corrigir quaisquer problemas identificados. \n\
  Se você encontrar algum bug ou tiver algum feedback, por favor, nos informe através do email:',

  thisMonth: 'Este mês',
  toGetBackToNavigation: 'para voltar para a navegação',
  today: 'Hoje',
  tomographies: 'Tomografias',
  topic: 'Tópico',
  torax: 'Tórax',
  totalExamsResults: 'Resultados de exames totais',
  tryGoingBackOrVisit: 'Tente voltar para a página anterior ou visite',
  type: 'Tipo',
  typeFieldsToContinue:
    'Para continuar, preencha os campos abaixo com seu e-mail e senha.',
  typeYourEmail: 'Digite seu e-mail',
  typeYourFeedback: 'Digite seu feedback',
  typeYourPassword: 'Digite sua senha',
  typedAddressIncorrectly:
    'Você pode ter digitado o endereço incorretamente ou a página pode ter sido removida',
  undefined: 'Indefinida',
  uploadFiles: 'Upload de Arquivos',
  updateResults: 'Atualizar resultados',
  uploadPath: 'Upload do path',
  uploaded: 'carregado',
  uploading: 'carregando',
  uploadingDicomFilesToTheServer: 'Subindo os arquivos DICOM para o servidor',
  us: 'Ultrasound',
  userPermissionsError : "É obrigatorio  definir pelo menos uma permissão.",
  noInstutionBodyInfo: 'Este usuário não está vinculado a nenhuma instituição no momento. Entre em contato com o administrador do sistema para vincular o usuário e habilitar as permissões de acesso',
  va: 'Visual Acuity',
  viewSeries: 'Visualizar série',
  viewCompleteSeries: 'Visualizar série no OSIMIS',
  viewOHIF: 'Visualizar série no OHIF',
  viewStone: 'Visualizar série no STONE',
  viewStudy: "Visualizar estudo",
  versionsTitle: 'Versões',
  version: 'Versão',
  waitingAuthorization: 'Aguardando Autorização',
  weNeedToMakeDureYouAreYourself:
    'Legal, precisamos verificar se você é você mesmo',
  weSendATokenCodeToYourEmail: 'Enviamos um código token para o seu email',
  weight: 'Peso',
  wellAerated: 'Bem Arejado',
  whenAgreeResultsMeansAgreeWithSegmentationAndClassification:
    'Quando você concorda com os resultados, significa concordar com a segmentação do parênquima e a classificação dada.',
  xa: 'X-Ray Angiography',
  xc: 'External-camera Photography',
  year: 'ano',
  years: 'anos',
  yesIDo: 'Sim, eu quero',
  youCanChooseMoreExamToRegister:
    'Você pode escolher mais de um exame para se registrar',
  youCanEditAdminInfoBelow:
    'Você pode editar as informações do administrador abaixo',
  yourReviewWasSentSucessfully: 'Sua revisão foi enviada com sucesso',
  yourOpinion: 'Sua opinião é valiosa para nós.',
  zipCode: 'CEP',

  //cadastrar
  firstAcess: 'Primeiro Acesso',
  helloWelcome: 'Olá, seja bem-vindo à plataforma HealthScan.',
  enterInformation: 'Digite os dados abaixo para criar o seu login.',

  typeYourName: 'Digite seu nome',
  typeYourLastName: 'Digite seu sobrenome',
  typeYourConstitutionalEmail: 'Digite seu e-mail cadastrado pela sua instituição',
  typeYourCPF: 'Digite seu CPF',
  createAPassword: 'Crie uma senha',
  confirmYourPassword: 'Confirme sua senha',
  passwordInstructions: 'Ela deve ser alfanumérica, contendo no mínimo 6 caracteres, com pelo menos uma letra maiúscula e pelo menos um caractere especial',
  agreeWithTerms: 'Concordar com',
  agreeWithTermsOfService: 'Termos e Condições de uso',
  agreeWithPolicy: 'Política de Privacidade e Segurança',

  firstNameRequired: 'Nome obrigatório',
  lastNameRequired: 'Sobrenome obrigatório',
  validEmailRequired: 'E-mail válido obrigatório',
  passwordMinLength: 'A senha deve ter no mínimo 8 caracteres.',
  passwordUppercase: 'A senha deve conter pelo menos uma letra maiúscula.',
  passwordLowercase: 'A senha deve conter pelo menos uma letra minúscula.',
  passwordNumber: 'A senha deve conter pelo menos um número.',
  passwordSpecialChar: 'A senha deve conter pelo menos um caractere especial, tipo !@#%^&*.()',
  passwordsDoNotMatch: 'Senhas diferentes',
  passwordRequired: 'Senha obrigatória',
  validCpfRequired: 'CPF válido obrigatório',
  acceptanceRequired: 'Aceite obrigatório',

  alreadyHaveAccount: 'Já possui cadastro?',
  loginHere: 'Faça login aqui',
  logout: 'Sair',


  //redefinição de senha
  emailInvalid: 'Por favor, insira um e-mail válido.',
  emailError: 'Erro ao enviar a solicitação. Tente novamente.',
  emailNotRegistered: 'E-mail não registrado no Healthscan.',
  requestSent: 'Solicitação enviada! Verifique seu e-mail para redefinir sua senha.',
  passwordReset: 'Senha redefinida com sucesso! Você pode fazer login agora.',
  errorPasswordReset: 'Erro ao redefinir a senha. Tente novamente.',
  requestPassword: 'Solicitar senha',
  requestPasswordInstructions: 'Preencha com o seu e-mail e nele receberá as informações necessárias para a troca de senha',
  requestReset: 'Solicitar redefinição',

  resetPassword: 'Redefinir Senha',
  newPassword: 'Nova senha',
  confirmNewPassword: 'Confirme a nova senha',

  // windowing presets
  preset_lungs1: 'Pulmões [W:1600 L:-400]',
  preset_lungs2: 'Pulmões [W:1500 L:-600]',
  preset_mediastinum: 'Mediastino [W:350 L:50]',
  preset_abdomen: 'Abdômen [W:400 L:60]',
  preset_bones: 'Ossos [W:1500 L:300]',
  preset_chest: 'Peito [W:400 L:40]',
  preset_angio: 'Angio [W:600 L:300]',

  //anotador
  any: 'Filtro para anotação',
  brain: 'Cérebro',
  bones:'Ossos',
  mediastinum: 'Mediastino',
  lungs: 'Pulmões',
  softtissue: 'Tecido mole',

  point: 'Ponto (2D)',
  sphere: 'Esfera (3D)',

  normal: 'Atenuação Normal',
  high: 'Atenuação Alta',
  low: 'Atenuação Baixa',
  subpleural: 'Linha Subpleural',
  reticular: 'Reticulações',
  nodular: 'Nódulos',
  osteoporosis: 'Osteoporose',
  ground: 'Vidro Fosco',
  honeycombing: 'Faveolamento',
  centrilobular: 'Nódulo Centrolobular',
  linear: 'Bandas Parenquimatosas',
  cyst: 'Cistos do Espaço Aéreo',
  fibronodular: 'Fibronodular',
  crazy: 'Pavimentação em Mosaico',
  consolidation: 'Consolidação',
  bronchiectasis: 'Bronquiectasia',
  bronchiolectasis: 'Bronquiolectasia de Tração',
  myosteatosis: 'Mioesteatose',

  basal: 'Padrão Reticular Basal Subpleural',
  thickening: 'Espessamento dos Septos Interlobulares',
  dorsalgroundglass: 'Vidro Fosco nos Campos Posteriores e Dorsais',
  periosteofitary: 'Vidro Fosco Periosteofitário',
  thincysts: 'Cistos do Espaço Aéreo com Paredes Finas',
  bronchial: 'Espessamento Parietal Brônquico',
  bronchialdilation: 'Ectasia/Dilatação Brônquica',
  tracheobronchialcalcifications: 'Calcificações das Cartilagens Traqueobrônquicas',
  fibrostreaks: 'Estrias Fibroatelectásicas',
  subsegmentalatelectasis: 'Atelectasias Subsegmentares',
  parenchymalbands: 'Bandas Parenquimatosas',
  centrilobularemphysema: 'Enfisema Centrolobular',
  subpleuralemphysema: 'Enfisema Subpleural',
  paraseptalemphysema: 'Enfisema Parasseptal',
  pulmonarycavitation: 'Cavitação Pulmonar',
  deformity: 'Deformidade Traqueal',

  smallernodules: 'Nódulos Menores que 6 mm',
  largernodules: 'Nódulos Maiores que 6 mm',
  granulomas: 'Granulomas (Micronódulos Calcificados)',
  pleuralthickening: 'Espessamento Pleural',
  pleuralplaques: 'Placas Pleurais',
  pleuraleffusion: 'Derrame Pleural',
  diaphragmatichernia: 'Hérnia Diafragmática',
  diaphragmaticfolds: 'Pregas Diafragmáticas',
  ascendingaortadilation: 'Ectasia/Dilatação da Aorta Ascendente (> 30 mm)',
  ascendingaortacalcifications: 'Calcificações de Aorta Ascendente',
  descendingaortacalcifications: 'Calcificações de Aorta Descendente',
  coronary: 'Calcificações Coronarianas',
  dorsal: 'Espondilose da Coluna Dorsal',
  hepatic: 'Esteatose Hepática',
  hepatomegaly: 'Hepatomegalia',
  splenomegaly: 'Esplenomegalia',

  // Tipo predominante de infiltrado
  heterogenousopacity: 'Opacidade Heterogênea',
  homogeneousopacitywithoutaerobroncogram: 'Opacidade Homogênea sem Aerobroncograma',
  opacitywithaerobroncogram: 'Opacidade com Aerobroncograma',
  cavitation: 'Cavitação',
  diffusereticularnodularinfiltrate: 'Infiltrado Retículo-nodular Difuso',
  localizedreticularnodularinfiltrate: 'Infiltrado Retículo-nodular Localizado',
  reticularinterstitialinfiltrate: 'Infiltrado Intersticial Reticular',
  singlecalcifiednodule: 'Nódulo Único Calcificado',
  singlenoncalcifiednodule: 'Nódulo Único Não Calcificado',
  smallnodules: 'Pequenos Nódulos',
  structuralchangesretractiveaspatct: 'Alterações Estruturais de Aspecto Retrátil',
  bullae: 'Bolha',
  fibroatelectasis: 'Fibroatelectasia',
  segmentalatelectasis: 'Atelectasia segmentar',
  subsegmentalatelectasis: 'Atelectasia subsegmentar',
  laminaratelectasis: 'Atelectasia laminar',

  // Comprometimento pleural
  pleuraleffusionuptofiventhrib: 'Derrame Pleural até o 5º Arco Costal',
  pleuraleffusionuptothirdrib: 'Derrame Pleural até o 3º Arco Costal',
  pleuraleffusionabovethirdrib: 'Derrame Pleural acima do 3º Arco Costal',
  obscurationofcostophrenicsinus: 'Velamento do Seio Costo-frênico',

  // Lesões
  militarytuberculosis: 'Tuberculose Miliar',
  pericardialeffusion: 'Derrame Pericárdico',

  // Linfoadenopatia
  hilarlymphadenopathy: 'Hilar',
  mediastinallymphadenopathy: 'Mediastinal',

  predominantInfiltrateType: 'Tipo predominante de infiltrado',
  pleuralCompromise: 'Comprometimento pleural',
  lesions: 'Lesões',
  lymphadenopathy: 'Linfoadenopatia',

  opportunisticScreeningChestCT: 'Rastreio oportunístico na Tomografia de Tórax',
  findingsChestCTElderly: 'Achados na Tomografia de Tórax em Idosos',
  disease: 'Doença', 
  attenuationPattern: 'Padrão de Atenuação',

  uploadSuccess: 'A máscara foi enviada com sucesso ao servidor',
  uploadError: 'Não foi possível enviar a máscara para o servidor',

  undoMaskChanges: 'Desfazer alterações',
  areYouSureUndoMaskChanges: 'Tem certeza que deseja desfazer todas as alterações da máscara?',
  afterConfirmationUndoMaskChanges: 'Após confirmação as alterações serão apagadas por completo.',
};

export default pt;
